<template>
  <div class="body">
    <div class="title">
      帖子管理
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>发布管理</el-breadcrumb-item>
          <el-breadcrumb-item>帖子管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
<!--        <el-dropdown class="rightfile">-->
<!--        <button size="medium" class="btn">-->
<!--          发布<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></button>-->
<!--          <el-dropdown-menu slot="dropdown" type="primary">-->
<!--            <el-dropdown-item  v-for="(item, index ) in fabubankuaiList" :key="index">-->
<!--              <div @click="routebankuai(item)" class="boxdro">-->
<!--                {{ item.name }}-->
<!--              </div>-->
<!--            </el-dropdown-item>-->
<!--          </el-dropdown-menu>-->
<!--        </el-dropdown>-->
      </div>
      <div style="flex: 1"></div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-select  placeholder="上下架" v-model="Query.is_status" @change="Discountsearch"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="0" label="全部 "></el-option>
              <el-option  name="selected" :value="1" label="下架 "></el-option>
              <el-option  name="selected" :value="2" label="上架 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="申请日期"
              v-model="Query.create_date"
              @change="Discountsearch">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-cascader :props="checkedData.typeOptions" @change="changList" clearable></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="发布板块" v-model="Query.types"  @change="Discountsearch" style="min-width: 168px;width: 168px" clearable>
              <el-option
                v-for="item in optiontype"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="审核状态" v-model="Query.verify_status" @change="Discountsearch"   style="min-width: 168px;width: 168px" clearable>
        <el-option
              v-for="item in shenheTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="排序/跳转链接/链接说明 " style="min-width: 168px;width: 336px;" v-model="Query.keyword" @input="Discountsearch">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <vxe-table
      border
      show-overflow
      keep-source
      ref="xTable"
      max-height="750"
      class="mytable-scrollbar"
      :data="tableData"
      align="center"
      :edit-config="{trigger: 'click', mode: 'cell', icon: 'fa fa-pencil', showStatus: true}">
      <vxe-table-column type="seq" width="60"></vxe-table-column>
      <vxe-table-column field="typename" title="发布板块" width="100"></vxe-table-column>
      <vxe-table-column field="name" title="发布标题" width="100"></vxe-table-column>
      <vxe-table-column field="realname" title="发布者" width="100"></vxe-table-column>
      <vxe-table-column field="mobile" title="联系电话" width="200"></vxe-table-column>
      <vxe-table-column field="addtime" title="发布时间" width="200"></vxe-table-column>
      <vxe-table-column  title="帖子状态" width="100">
        <template  slot-scope="scope">
          <span v-if="scope.row.verify_status === 0" class="daitongguo">待通过</span>
          <span v-if="scope.row.verify_status === 2" class="weizhiding">未通过</span>
          <span v-if="scope.row.verify_status === 1" class="yizhiding">已通过</span>
        </template>
      </vxe-table-column>
      <vxe-table-column  title="上架状态" width="100">
        <template  slot-scope="scope">
          <el-switch
            @change="sexChangeListOption(scope.row)"
            v-model="scope.row.shangjia"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
          <span :style="{'color': (scope.row.is_status === 0 ? '#F7D05C':'#17ab3f')}">
            {{scope.row.is_status===1 ?'上架':'下架'}}
          </span>
        </template>
      </vxe-table-column>
      <vxe-table-column  title="置顶状态" width="100">
        <template  slot-scope="scope">
          <span v-if="scope.row.is_top === 0" class="weizhiding">未置顶</span>
          <span v-if="scope.row.is_top === 1" class="yizhiding">置顶(剩余{{scope.row.istop_surplusdays}}天)</span>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" min-width="200">
        <template slot-scope="scope">
         <div class="row">
           <button  size="mini" @click="chakanxiangqing(scope.row)" class="sdbutton">查看详情</button>
           <button  size="mini" @click="zhidingjilu(scope.row)"  class="sdbutton">置顶记录</button>
           <button  size="mini" @click="deltiezi(scope.row)"  class="sdbutton">删除</button>
         </div>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10,15,20]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <vxe-modal width="336" ref="shifoushangjia" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="plClose">
        <div class="titledd">
          是否确认{{itemcc.is_status===1?'下架':'上架'}}该帖子?
        </div>
        <div class="bobox">
          <button class="queren" @click="plqueren">
            确认
          </button>
          <button class="quxiao"  @click="plClose">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal ref="dakaizhiding" title="开通记录" width="1200" height="400" :mask="false" :lock-view="false" resize>
      <template #default>
        <div class="headetrxsadf">
          <div class="leftdsss">
            <div class="titleddss">
              {{ zhidingQuery.org_com }}
            </div>
          </div>
          <div class="right">
            <div class="huiyuanzhuangtai">
              会员状态
              <span class="sdadwee" :style="{'color': (zhidingQuery.istop_surplusdays === 0 ? '#000000':'#0FA838')}">
                {{zhidingQuery.istop_surplusdays === 0 ? '普通用户': '会员'}}
              </span>
              <span class="sadgggvv" v-if="zhidingQuery.istop_surplusdays !== 0">
                (剩余{{ zhidingQuery.istop_surplusdays }}天)
              </span>
            </div>
          </div>
        </div>
        <vxe-table
          border
          show-overflow
          keep-source
          ref="xTable"
          max-height="400"
          :data="zhidingQuery.top_pay"
          align="center"
          :edit-config="{trigger: 'click', mode: 'cell', icon: 'fa fa-pencil', showStatus: true}">
          <vxe-table-column type="seq" width="60"></vxe-table-column>
          <vxe-table-column field="modular_name" title="置顶类型"></vxe-table-column>
          <vxe-table-column field="paytime" title="开通时间"></vxe-table-column>
          <vxe-table-column field="days" title="开通时长/天"></vxe-table-column>
          <vxe-table-column field="paymoney" title="收费金额/元"></vxe-table-column>
          <vxe-table-column field="pay_type" title="支付方式 "></vxe-table-column>
          <vxe-table-column field="order_no" title="订单号" width="260"></vxe-table-column>
        </vxe-table>
      </template>
    </vxe-modal>
</div>
</template>

<script>
import { tieziliebiao, postSetstatusval, postIstoprecord, postDel } from '@/api/tiezi'
import { city, province } from '@/api/city'

export default {
  name: 'index',
  data () {
    return {
      total: null,
      checkedData: {
        // sendData: ['province_name'], // 默认选中值
        typeOptions: {
          lazy: true, // 开启懒加载
          lazyLoad: this.lazyLoad
        }
      },
      shenheTypes: [
        {
          value: '0',
          label: '全部 '
        },
        {
          value: '1',
          label: '未审核 '
        },
        {
          value: '2',
          label: '已审核 '
        },
        {
          value: '3',
          label: '拒绝 '
        }
      ],
      optiontype: [
        {
          value: '0',
          label: '全部 '
        }, {
          value: '1',
          label: '二手转让'
        },
        {
          value: '2',
          label: '供需大厅'
        },
        {
          value: '3',
          label: '招商加盟'
        },
        {
          value: '4',
          label: '求租求购'
        },
        {
          value: '5',
          label: '房产中介'
        },
        {
          value: '6',
          label: '人才招聘'
        }
      ],
      pageshow: true,
      cur_page: 1,
      tableData: [
      ],
      fabubankuaiList: [
        {
          name: '二手转让'
        },
        {
          name: '人才招聘'
        },
        {
          name: '人才招聘'
        },
        {
          name: '批发导购'
        },
        {
          name: '招商加盟'
        },
        {
          name: '求租求购'
        }
      ],
      Query: {
        token: sessionStorage.getItem('token'),
        create_date: '',
        province_id: 0,
        city_id: 0,
        types: null,
        verify_status: null,
        keyword: '',
        page: 1,
        pagesize: 10,
        total: null,
        is_status: 0
      },
      itemcc: {},
      zhidingQuery: {}
    }
  },
  created () {
    this.tiezicc()
  },
  methods: {
    deltiezi (item) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const obj = {
            token: sessionStorage.getItem('token'),
            id: item.id
          }
          postDel(obj).then(({ data: res }) => {
            console.log('postDel', res)
            if (res.result === -1) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: '2000'
              })
              setTimeout(() => {
                window.sessionStorage.clear()
                this.$router.push('/login')
              }, 1000)
            }
            if (res.result === 0) {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: '2000'
              })
              return false
            }
            if (res.result === 1) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: '2000'
              })
              this.handleCurrentChange(this.Query.page)
            }
          })
        })
        .catch(() => {});
    },
    changList (val) {
      this.Query.province_id = val[0]
      this.Query.city_id = val[1]
      this.Discountsearch()
    },
    async lazyLoad (node, resolve) {
      const level = node.level
      let result
      let res
      let param
      switch (level) {
        case 0: // 一级
          res = await province()
          result = res.data.list
          result.forEach((item) => {
            item.value = item.province_id
            item.label = item.province_name
          })
          break
        case 1: // 二级
          console.log(node.data.province_id)
          param = {
            province_id: node.data.province_id
          }
          res = await city(
            param
          )
          result = res.data.list
          // console.log(result)
          result.forEach((item) => {
            item.value = item.city_id
            item.label = item.city_name
            item.leaf = level >= 1
          })
          break
        // case 2: // 三级目录
        //   console.log(node.data.city_id)
        //   param = {
        //     city_id: node.data.city_id
        //   }
        //   res = await area(
        //     param
        //   )
        //   result = res.data.list
        //   result.forEach((item) => {
        //     item.value = item.area_id
        //     item.label = item.area_name
        //     item.leaf = level >= 2
        //   })
        //   break
        // case 3: // 三级目录
        //   param = {
        //     area_id: node.data.area_id
        //   }
        // res = await getStreet(
        //   param
        // )
        // result = res.list
        // result.forEach((item) => {
        //   item.value = item.street_id
        //   item.label = item.short_name
        //   // 大于三级后不再显示后面的，到此结束
        //   item.leaf = level >= 3
        // })
        // break
        default:
          result = []
          break
      }
      console.log(result)
      resolve(result)
    },
    zhidingjilu (row) {
      this.$refs.dakaizhiding.open()
      const obj = {
        token: sessionStorage.getItem('token'),
        id: row.id
      }
      postIstoprecord(obj).then(({ data: res }) => {
        console.log('resssadca', res)
        this.zhidingQuery = res
      })
    },
    plqueren () {
      if (this.itemcc.is_status === 1) {
        this.itemcc.is_status = 0
      } else {
        this.itemcc.is_status = 1
      }
      const obj = {
        token: sessionStorage.getItem('token'),
        id: this.itemcc.id,
        is_status: this.itemcc.is_status
      }
      postSetstatusval(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.shifoushangjia.close()
          this.xiehuiList()
        }
      })
    },
    plClose () {
      this.$refs.shifoushangjia.close()
      this.tiezicc()
    },
    sexChangeListOption (item) {
      console.log('row', item)
      this.itemcc = item
      this.$refs.shifoushangjia.open()
    },
    handleSizeChange (val) {
      this.Query.pagesize = val
      this.handleCurrentChange(this.Query.page)
    },
    handleCurrentChange (val) {
      this.Query.page = val
      const obj = {
        token: sessionStorage.getItem('token'),
        create_date: this.Query.create_date,
        province_id: this.Query.province_id,
        city_id: this.Query.city_id,
        types: this.Query.types,
        verify_status: this.Query.verify_status,
        keyword: this.Query.keyword,
        page: this.Query.page,
        pagesize: this.Query.pagesize,
        total: this.Query.total
      }
      tieziliebiao(obj).then(({ data: res }) => {
        console.log('rescc', res)
        this.tableData = res.list
        this.total = res.total
        this.tableData.forEach(i => {
          if (i.is_status === 0) {
            i.shangjia = false
          } else if (i.is_status === 1) {
            i.shangjia = true
          }
        })
      })
    },
    Discountsearch () {
      this.Query.page = 1
      this.cur_page = 1
      this.tiezicc()
      this.pageshow = false// 让分页隐藏
      this.$nextTick(() => { // 重新渲染分页
        this.pageshow = true
      })
    },
    tiezicc () {
      tieziliebiao(this.Query).then(({ data: res }) => {
        console.log('rescc', res)
        this.tableData = res.list
        this.total = res.total
        this.tableData.forEach(i => {
          if (i.is_status === 0) {
            i.shangjia = false
          } else if (i.is_status === 1) {
            i.shangjia = true
          }
        })
      })
    },
    chakanxiangqing (row) {
      console.log(row)
      this.$store.commit('setfabuID', row.id)
      this.$router.push('/tiezichakanxiangqing')
    },
    routebankuai (item) {
      console.log(item.name)
      this.$store.commit('setFabubankuai', item.name)
      this.$router.push('/fabutiezi')
    }
  }
}
</script>

<style lang="less">
.el-scrollbar__wrap{
  height: 200px ;
}
.headetrxsadf{
  display:flex;
  flex-direction: row;
  height: 74px;
  align-items: center;
  .leftdsss{
    display:flex;
    flex-direction: row;
    align-items: center;
    flex:1;
    .titleddss{
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Heavy;
      font-weight: 800;
      //text-align: left;
      color: #2e2e2e;
      .idss{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        //text-align: left;
        color: #2e2e2e;
      }
    }
  }
  .right{
    display:flex;
    flex-direction: row;
    align-items: center;
    .huiyuanzhuangtai{
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Heavy;
      font-weight: 800;
      text-align: left;
      color: #a1a1a1;
      margin-right: 8px;
      .sdadwee{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        text-align: left;
      }
      .sadgggvv{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        text-align: left;
        color: #0FA838;
      }
    }
  }
}
.sdbutton{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61,154,255,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #3d9aff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  margin-right: 12px;
}
.popchuangkou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP{
    margin-bottom: 24px;
  }
  .dsff{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd{
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput{
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox{
    margin-top: 43px;
    display:flex;
    flex-direction: row;
    align-items: center;
  }
  .queren{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61,154,255,0.10);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.daitongguo{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #f7d05c;
  letter-spacing: 0px;
}
.weizhiding{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #f7d05c;
  letter-spacing: 0px;
}
.yizhiding{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #0fa838;
  letter-spacing: 0px;
}
.body {
  display: flex;
  flex-direction: column;
.title {
  opacity: 1;
  font-size: 30px;
  font-family: PingFang SC, PingFang SC-Heavy;
  font-weight: 800;
  text-align: left;
  color: #2e2e2e;
  letter-spacing: 0px;
  margin-bottom: 35px;
  display:flex;
  flex-direction: row;
  align-items: center;
.fansk{
  margin-top: 30px;
  margin-left: 32px;
}
.dsadf{
  color: #3D9AFF;
}
}
  .btnsearch{
    display:flex;
    flex-direction: row;
    align-items: center;
    .left{
      margin-right: 150px;
      .btn{
        width: 95px;
        height: 43px;
        opacity: 1;
        background: linear-gradient(135deg,#3d9aff, #3380f2);
        border-radius: 5px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #ffffff;
        letter-spacing: 0px;
        border:none;
        display: flex;
        justify-content: center;
        align-items: center;
        .boxdro{
          width: 173px;
          height: 50px;
          opacity: 1;
          background: #f6f7fc;
          .el-dropdown {
            vertical-align: top;
          }
          .el-dropdown + .el-dropdown {
            margin-left: 15px;
          }
          .el-icon-arrow-down {
            font-size: 12px;
          }
        }
      }
    }
    .right{
      margin-top: 27px;
    }
  }
}
</style>
